export default __webpack_public_path__ + "static/media/megaphone_white.98ee0bf3.svg";